import useAuthenticate from '../../components/authentication/authenticate';
import MDashboard from './MDashboard';
import RDashboard from './RDashboard';

const Dashboard = () => {
    const { user, isLoading } = useAuthenticate();

    if (isLoading) return <div>Loading...</div>;

    const role = Object.keys(user?.user?.active || {})[0]; // 'manager', 'owner', 'tenant', etc.

    if (role === 'manager') {
        return <MDashboard />;
    } else if (role === 'owner' || role === 'tenant') {
        return <RDashboard />;
    }
};

export default Dashboard;
